<template>
	<div>
		<p class="mb-4">
			<div class="button icon-button">
				<img src="../../../../assets/images/icons/solid/angle-left-white.svg" width="13" class="mr-2" />
				<span>BACK TO THE PROGRAM DASHBOARD</span>
			</div>
		</p>
		
    	<div class="h2 darkgray mb-4 regular pb-3 border-bottom"><strong class="green">HHA:</strong> <span class="">{{ provider_data.first_name }}</span></div>
    	<div class="row">
	    	<div class="col-12 col-md-6 d-md-flex ">
		    	<div class="conversation w-100 d-flex justify-content-end p-3 lightgray-content">
			    	<div v-if="messages != null" class="flex-fill">
			    		<div class="h5 regular mb-5 border-bottom pb-2">Messages</div>
			    		<div v-if="messages.length > 0">
					    	<ul class="messages">
						    	<li class="answer" v-for="message in messages">
						    		<header class="d-flex justify-content-between mb-1">
							    		<strong><small>Nevvon</small></strong>
							    		<div class="date">Sent in {{ message.sent_at }} / Read at {{ message.read_at }}</div>
						    		</header>
						    		<div class="d-flex">
							    		<div class="thumb-container" style="background-image: url(http://nevvon.com/logo.png)"></div>
							    		<div class="message flex-fill">{{ message.text }}</div>
						    		</div>
						    	</li>
					    	</ul>
			    		</div>
			    		<div v-else>
				    		<p class="mt-5 mb-5"><strong>There aren't messages in this conversation.</strong></p>
			    		</div>
				    	
				    	<div class="text-entry d-flex justify-content-between">
					    	<div class="flex-fill d-flex">
						    	<div class="input-content flex-fill m-0">
						    		<input type="text" class="flex-fill" placeholder="Type Message" v-model="text_to_send"/>
						    	</div>
						    	<button class="button m-0" type="submit" @click="sendMessage">
						    		<img src="../../../../assets/images/icon_envelope_white.svg" class="mr-1" width="18" /> SEND
								</button>
					    	</div>
					    	<div class="pl-2">
						    	<img src="../../../../assets/images/icons/solid/paperclip.svg" width="27" />
					    	</div>
				    	</div>
			    	</div>
		    	</div><!--conversation-->
	    	</div><!--col-->
	    	<div class="col-12 col-md-6">
		    	<div class="profile-presentation p-3 mb-4">
			        <div class="h5 border-bottom pb-2 regular">HHA info</div>
	                <div class="row">
		                <div class="col-12 col-sm-6">
							<div class="thumb-container pb-100 profile-thumb" :style="{ 'background-image': 'url(' + provider_data.image + ')' }"></div>
		                </div><!--col-->
		                <div class="col-12 col-sm-6">
			                <ul class="icon-list list-unstyled">
				                <li class="d-flex align-items-center mb-2 ">
				                	<span class="mr-2"><img src="../../../../assets/images/icons/solid/user_green.svg" width="22" /></span>
				                	<span>Name: <strong>{{ provider_data.first_name }}</strong></span>
				                </li>
				                <li class="d-flex align-items-center mb-2">
				                	<span class="mr-2"><img src="../../../../assets/images/icons/solid/phone_green.svg" width="22" /></span>
				                	<span>Telephone: <strong>555-6789</strong></span>
				                </li>
				                <li class="d-flex align-items-center mb-2">
				                	<span class="mr-2"><img src="../../../../assets/images/icons/solid/envelope_green.svg" width="22" /></span>
				                	<span>Email: <strong>{{ provider_data.email }}</strong></span>
				                </li>
				                <li class="d-flex align-items-center mb-2">
				                	<span class="mr-2"><img src="../../../../assets/images/icons/solid/globe_green.svg" width="22" /></span>
				                	<span>Language: <strong>English</strong></span>
				                </li>
				                <li class="d-flex align-items-center mb-2">
				                	<span class="mr-2"><img src="../../../../assets/images/icons/solid/trophy_green.svg" width="22" /></span>
				                	<span>Rank: <strong>27</strong></span>
				                </li>
				                <li class="d-flex align-items-center mb-2">
				                	<span class="mr-2"><img src="../../../../assets/images/icons/solid/map-marker_green.svg" width="22" /></span>
				                	<span>Address: <strong>Street</strong></span>
				                </li>
			                </ul>
			                
					                
		                </div><!--col-->
	                </div><!--row-->
	                <div class="row">
		                <div class="col-12 mb-4">
		               		<div class="h5 mt-4 border-bottom pb-2 regular">Performance</div>
					   		<course-progression-chart :height="100" />
					   		<div class="h5 mt-4 border-bottom pb-2 regular">Courses</div>
				            <p>
					            <a href="#">
					            	<img class="mr-2" src="../../../../assets/images/icons/solid/book.svg" width="20" />
					            	<span>Course 1</span>
					            </a>
				            </p>
				            <p>
					            <a href="#">
					            	<img class="mr-2" src="../../../../assets/images/icons/solid/book.svg" width="20" />
					            	<span>Course 2</span>
					            </a>
				            </p>
				            <p>
					            <a href="#">
					            	<img class="mr-2" src="../../../../assets/images/icons/solid/book.svg" width="20" />
					            	<span>Course 3</span>
					            </a>
				            </p>
		                </div><!--col-->
	                </div><!--row-->
                </div><!--profile_presentation-->
	    	</div><!--col-->
    	</div><!--row-->
	</div>	
</template>

<script>
	
	
	import CourseProgressionChart from './../../../charts/CourseProgressionChart.js';
	
	export default {
		
	    components : {
	        CourseProgressionChart
	    },
		data : function(){
			return {
				id : this.$route.params.id,
				provider_id : this.$route.params.provider_id,
				provider_data : {
					email : '',
					first_name : '',
					last_name : '',
					// dob : ''
				},
				messages : null,
				text_to_send : ''
			}
		},

		created : function(){
			this.getProvider();
			this.getMessages();
		},

		methods : {

			getProvider : function(){

				var params = {
					id : this.provider_id
				}

				this.$store.dispatch('getProvider', params).then((res) => {
					this.provider_data = res.data.data;
				}).catch((error) => {	
					console.log(error);
				})
			},

			getMessages : function(){
				var params = {
					id : this.id, 
					provider_id : this.provider_id
				}

				this.$store.dispatch('getCourseProviderMessages', params).then((res) => {
					this.messages = res.data.messages;
				}).catch((error) => {
					console.log(error);
				})
			},

			sendMessage : function(){
				var params = {
					id : this.id,
					provider_id : this.provider_id,
					text : this.text_to_send
				}

				this.$store.dispatch('sendMessageToCourseProvider', params).then((res) => {
					this.text_to_send = '';
					this.getMessages();
				}).catch((error) => {
					console.log(error);
				});
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/organizations/courses/providers/OrganizationCourseProviderMessageComponent.vue